import TripCreatorContainer from "../../components/trip-planning/TripCreator";

export default function CreateTrip() {
  return <TripCreatorContainer />;
}
